export const getServerLink = () => import.meta.env.REACT_APP_API_URL;
